var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPictoCredit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-picto-cr\xC3\xA9dit"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4241 14.3106C20.7577 14.3106 21.0281 14.627 21.0281 15.0162C21.0281 15.4066 20.7577 15.7222 20.4241 15.7222C20.0905 15.7222 19.8197 15.4066 19.8197 15.0162C19.8201 14.627 20.0905 14.3106 20.4241 14.3106ZM18.3477 16.8566H22.9249V13.177H18.3477V16.8566Z",
    fill: "#120136"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79448 8.57068L19.0665 5.69708C19.1805 5.66188 19.2953 5.67788 19.4073 5.74548C19.5909 5.85748 19.7309 6.08988 19.7805 6.36828L20.1749 8.57068H9.79448ZM22.9241 12.4979V9.77148C22.9241 9.10948 22.4577 8.57068 21.8841 8.57068H20.8637L20.4481 6.24828C20.3637 5.77428 20.1121 5.38028 19.7589 5.16508C19.4825 4.99708 19.1645 4.95548 18.8649 5.04868L7.68208 8.51428C7.38968 8.60428 7.13087 8.81988 6.95407 9.12028L6.96287 9.12588C6.85927 9.31268 6.79688 9.53348 6.79688 9.77148V15.4039C7.25008 15.2727 7.72887 15.1995 8.22487 15.1995C10.9973 15.1995 13.2525 17.3979 13.2525 20.1003C13.2525 20.5371 13.1929 20.9655 13.0773 21.3815H21.8837C22.4573 21.3815 22.9237 20.8427 22.9237 20.1807V17.5359H18.0073C17.8193 17.5359 17.6677 17.3839 17.6677 17.1963V12.8375C17.6681 12.6495 17.8201 12.4979 18.0073 12.4979H22.9241Z",
    fill: "#EEA961"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5976 20.5007C6.3764 20.5007 6.1972 20.3215 6.1972 20.0999C6.1972 19.8787 6.3768 19.6995 6.5976 19.6995H9.8552C10.0764 19.6995 10.2556 19.8787 10.2556 20.0999C10.2556 20.3215 10.076 20.5007 9.8548 20.5007H6.5976ZM8.226 16.0007C5.8956 16.0007 4 17.8399 4 20.1003C4 22.3607 5.8952 24.1999 8.226 24.1999C9.9756 24.1999 11.5652 23.1339 12.182 21.5467C12.3616 21.0855 12.4524 20.5987 12.4524 20.1003C12.4524 17.8399 10.5564 16.0007 8.226 16.0007Z",
    fill: "#CF5E1D"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPictoCredit);
export default __webpack_public_path__ + "static/media/ic-picto-credit.12160d37.svg";
export { ForwardRef as ReactComponent };